import Vue from 'vue'
import Vuex from 'vuex'
import {SHOPPING_LIST} from "@/store/mutation-types";
import {getAction} from "@/api/manage";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        shopping: [],
        cateMenuList:[],
        config:undefined,
        manufacturerList:[]
    },
    mutations: {
        setShopping (state,proList) {
            Vue.ls.set(SHOPPING_LIST,JSON.stringify(proList));
            state.shopping = proList;
        },
        addShopping (state,pro) {
            let list = Vue.ls.get(SHOPPING_LIST);
            if(!!list && !!JSON.parse(list)){
                list = JSON.parse(list);
                let nPro = list.find(item => item.id === pro.id || item.partNumber === pro.partNumber);
                //判断如果存在就加数量
                if (!!nPro) {
                    nPro.quantity +=pro.quantity
                }else{
                    list.push(pro)
                }
            }else{
                list = [];
                list.push(pro)
            }
            state.shopping = list
            Vue.ls.set(SHOPPING_LIST,JSON.stringify(list));
        },
        removeShopping (state,index){
            let list = Vue.ls.get(SHOPPING_LIST);
            if(!!list){
                list = JSON.parse(list)
                list.splice(index,1);
                state.shopping = list
                Vue.ls.set(SHOPPING_LIST,JSON.stringify(list));
            }
        },
        updateByIndex (state,{pro,index}){
            let list = Vue.ls.get(SHOPPING_LIST);
            if(!!list){
                list = JSON.parse(list);
                list[index] = pro;
                state.shopping[index] = pro
                Vue.ls.set(SHOPPING_LIST,JSON.stringify(list));
            }
        },
        setConfig (state, config){
            state.config = config;
        },
        setManufacturerList(state,list){
            state.manufacturerList = list;
        }
    },
    actions: {
        async fetchParts({ commit }) {
            try {
                // 调用 API 或其他获取数据的逻辑
                const parts = JSON.parse(Vue.ls.get(SHOPPING_LIST)); // 你需要实现这个方法

                // 提交 mutation 更新状态
                commit('setShopping', parts);
            } catch (error) {
                console.error('Error fetching parts:', error);
            }
        }
    },
    getters: {
        parts: state => {
            if (!Vue.ls.get(SHOPPING_LIST)) {
               return [{
                    partNumber:'',
                    manufacturer:'',
                    listDesc:'',
                    quantity:1,
                    targetPrice:0.00,
                    remark:''
                }];
            }
            state.shopping = JSON.parse(Vue.ls.get(SHOPPING_LIST))
            return state.shopping;
        },
        catemenuList: async state => {
            if (!state.cateMenuList || state.cateMenuList.length === 0) {
                await getAction("/front/home/cateMenuList", {}).then(res => {
                    state.cateMenuList = [];
                    res.result.cateMenuList.forEach(item => {
                        item.chilidShow = false;
                        state.cateMenuList.push(item)
                    })
                })
            }
            return state.cateMenuList;
        },
        getConfig:  state => {
            if(!state.config){
                getAction("/front/home/getConfig").then(res => {
                    if(res.success){
                        state.config = res.result;
                    }
                })
            }
            return state.config;
        },
        manufacturerList: state => {
            if (!state.manufacturerList || state.manufacturerList.length === 0) {
                getAction("/front/mallManufacturer/getList").then(res => {
                    if (res.success) {
                        state.manufacturerList = res.result
                    }
                })
            }
            return state.manufacturerList
        }
    }
})